import { render } from "./InvClasificaciones.vue?vue&type=template&id=be70fc88&scoped=true"
import script from "./InvClasificaciones.vue?vue&type=script&lang=js"
export * from "./InvClasificaciones.vue?vue&type=script&lang=js"

import "./InvClasificaciones.vue?vue&type=style&index=0&id=be70fc88&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be70fc88"]])

export default __exports__